import {NavigateFunction} from 'react-router-dom';

/**
 * Navigate to a path, supporting Cmd+Click (Mac) / Ctrl+Click (Windows) to open in new tab.
 * Use this instead of calling navigate() directly in onClick handlers.
 *
 * Usage:
 *   onClick={(e) => navigateTo(e, navigate, '/talents/123')}
 */
export default function navigateTo(
  e: React.MouseEvent | undefined,
  navigate: NavigateFunction,
  path: string,
): void {
  if (e && (e.metaKey || e.ctrlKey)) {
    window.open(path, '_blank');
    return;
  }
  navigate(path);
}
